import { forwardRef, InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react';
import clsx from 'clsx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    /** Inside the field, 12 px from the edge (currency, search icon). */
    leading?: ReactNode;
    /** Inside the field, 12 px from the edge (unit, show-password button). */
    trailing?: ReactNode;
}

/** 44 px text field. 16 px text so iOS does not zoom on focus. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
    { leading, trailing, className, ...rest },
    ref
) {
    if (!leading && !trailing) return <input ref={ref} className={clsx('field', className)} {...rest} />;
    return (
        <div className="relative">
            {leading && (
                <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-muted">{leading}</span>
            )}
            <input
                ref={ref}
                className={clsx('field', leading && 'pl-10', trailing && 'pr-12', className)}
                {...rest}
            />
            {trailing && <span className="absolute inset-y-0 right-1 flex items-center">{trailing}</span>}
        </div>
    );
});

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea(
    { className, ...rest },
    ref
) {
    return <textarea ref={ref} className={clsx('field', className)} {...rest} />;
});
